import { useEffect, useState } from 'react';
import projects from './projects.json'
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';



const Projects = () => {
    // Default JSON file to show everything before filtering
    const [project, setProjects] = useState(projects.projects)
    // To add options to select
    const termSet = Array.from(new Set(projects.projects.map(projects => projects.term)))
    console.log(project)


    return ( 
        <motion.div id="projects-box"
        initial={{opacity: 0}} 
        animate={{opacity: 1}} 
        // exit={{x: '-100vw', transition:{duration: 0.5}}}
        // transition={{type: 'spring', delay:0.1, stiffness: 20, duration: 1}}
        transition={{duration:0.5}}
        >
            <h2 className="projects-content">
                My projects
            </h2>
            <label htmlFor="prjterm" className="">Filter by term: </label>
            {/* Filter projects by term */}
            <select name="select" id="prjterm" value={project} onChange={e => {setProjects((projects.projects.filter(projects => projects.term === parseFloat(e.target.value))))}}>
                <option value={projects.projects}>Select</option>
                {termSet.map(term => (<option value={term}>{term}</option>))}
            </select>
            <button className='prj-link' onClick={() => setProjects(projects.projects)}>Reset</button>
            <div id="projectslist">
                
            {project && project.map((projects) => (
                <div className="project-preview" key={projects.id}>
                    <h4 className="title">Project {projects.title}</h4>
                    <div className="img-container">
                        <img src={projects.image} width="100%"/>
                    </div>
                    <hr />
                        <div className="button-links">
                            <a href={projects.link} className="prj-link">Visit</a>
                            <Link to={`/project/${projects.id}`} className='prj-link'>More Info</Link>
                        </div>
                </div>
                ))}
            </div>
        </motion.div>
    );
}
 
export default Projects;